<form [formGroup]="form" class="d-flex align-items-center" (ngSubmit)="submit()">
    <switch formControlName="switch" [inline]="true"></switch>
    <button class="btn btn-light btn-sm ms-2">Submit</button>
</form>
